<template>
  <SfSidebar
    :visible="isVisible"
    class="sf-sidebar--right sf-sidebar--icon sf-sidebar__store-selector modal-store-selector"
    @close="closeModal"
  >
    <div class="store-content">
      <div class="selected-store" v-if="selectedStore">
        <SfHeading
          class="sf-heading--left"
          :title="$t('Mein Markt: ') + selectedStore.name"
          :level="3"
        />
        <store-card
          :store="selectedStore"
        />
      </div>

      <div class="more-stores">
        <SfHeading
          v-if="hasProductContext"
          class="sf-heading--left"
          :title="'Verfügbarkeit in unseren Märkten'"
          :level="3"
        />
        <SfHeading
          v-else-if="selectedStore"
          class="sf-heading--left"
          :title="'Weitere Märkte'"
          :level="3"
        />
        <SfHeading
          v-else
          class="sf-heading--left"
          :title="'Unsere Märkte'"
          :level="3"
        />
        <p class="subtitle">
          Unsere Marktübersicht finden Sie <router-link :to="localizedRoute('/store')" @click.native="toStorePageAndClose">
            hier
          </router-link>.
        </p>
        <!-- store-map :stores="allStores" -->
        <!-- <iframe src="https://www.google.com/maps/d/u/0/embed?mid=1ULQ3cJGOipllv0FMJBnGTS-6jo0GE09L" width="100%" height="480" frameborder="0"></iframe> -->

        <div class="list-store">
          <div
            class="list-store-item"
            v-for="store in listedStores"
            :key="store.pickup_location_code"
            :value="store.pickup_location_code"
            :class="{ 'list-store-item--selected': isCurrentStore(store) }"
          >
            <store-card
              :store="store"
              :list-view="true"
            />
            <store-availability
              v-if="hasProductContext"
              :store="store"
              :product="modalData.payload"
              :qty="getStockQuantity(modalData.payload)"
              :qty-pickup="getStockQuantity(modalData.payload, store)"
            />
            <SfButton
              class="form__submit"
              :disabled="isCurrentStore(store)"
              @click="setCurrentStoreAndClose(store.pickup_location_code)"
            >
              {{ isCurrentStore(store) ? 'Ausgewählt' : 'Diesen Markt auswählen' }}
            </SfButton>
          </div>
        </div>
      </div>
    </div>
  </SfSidebar>
</template>

<script>
import i18n from '@vue-storefront/i18n';
import { SfSidebar, SfHeading, SfButton } from '@storefront-ui/vue';
import InventorySource from '../mixins/InventorySource'
import StoreSelector from '../mixins/StoreSelector'
import StoreCard from './StoreCard'
import StoreAvailability from './StoreAvailability'
import { localizedRoute } from '@vue-storefront/core/lib/multistore'
import { mapGetters } from 'vuex'
import { prepareSku, loadStock } from 'src/modules/vsf-inventory-sources/helpers/stockResolver';

export default {
  name: 'StoreSelectorModal',
  components: {
    SfSidebar,
    SfHeading,
    SfButton,
    StoreCard,
    StoreAvailability
  },
  mixins: [ InventorySource, StoreSelector ],
  props: {
    isVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    modalData: {
      type: Object,
      default: () => ({}),
      required: true
    }
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters({
      stockItems: 'inventorySources/getStockItems'
    }),
    hasProductContext () {
      return !!(this.modalData.payload && prepareSku(this.modalData.payload))
    },
    listedStores () {
      return this.getInventorySources.filter((s) => {
        // Always keep the currently selected market visible
        if (this.isCurrentStore(s)) {
          return true
        }
        // Product context: only show markets that have an MSI source-item for this SKU
        if (this.hasProductContext && !this.isStoreAssigned(s)) {
          return false
        }
        return true
      })
    },
    allStores () {
      return this.getInventorySources
    }
  },
  watch: {
    isVisible: {
      immediate: true,
      handler (visible) {
        if (visible && this.hasProductContext) {
          loadStock(this.modalData.payload)
        }
      }
    }
  },
  methods: {
    isCurrentStore (store) {
      return !!(
        this.selectedStore &&
        store &&
        store.pickup_location_code === this.selectedStore.pickup_location_code
      )
    },
    getSourceItem (product, store) {
      const pickupLocationCode = (store && store.pickup_location_code) ? store.pickup_location_code : 'online'
      return this.stockItems.find(s => s.sku === prepareSku(product) && s.source_code === pickupLocationCode)
    },
    /**
     * Online qty, or pickup qty when the store has an MSI source-item (assignment).
     * Unassigned stores (no source-item) return null → "nicht verfügbar".
     */
    getStockQuantity (product, store) {
      const item = this.getSourceItem(product, store)
      if (!store) {
        return item && item.quantity != null ? item.quantity : null
      }
      if (!item) {
        return null
      }
      return item.quantity != null ? item.quantity : 0
    },
    isStoreAssigned (store) {
      return !!this.getSourceItem(this.modalData.payload, store)
    },
    async setCurrentStoreAndClose (code) {
      if (this.selectedStore && this.selectedStore.pickup_location_code === code) {
        this.closeModal()
        return
      }
      await this.setCurrentStore(code)
      this.$emit('close', this.modalData.name)
    },
    closeModal () {
      this.$emit('close', this.modalData.name)
    },
    toStorePageAndClose () {
      this.$router.push({ path: localizedRoute('/store') })
      this.closeModal()
    }
  }
};
</script>
